// project imports
import { GuardProps } from 'types';

// ==============================|| PRIORITY GUARD ||============================== //

/**
 * Priority settings routes — always accessible from system settings.
 * @param {PropTypes.node} children children element/node
 */

export default function PriorityGuard({ children }: GuardProps) {
  return children;
}
